import {Component} from "@angular/core";

@Component({
  selector:'line',
  template:`
    <button type="button" data-toggle="modal2" data-target="#myModal5"></button>   
    <div id="myModal5" class="modal fade" role="dialog">
        <div class="modal-dialog">                    
            <div class="modal-content">                   
            <h2>wow</h2>                   
            </div>     
        </div>
    </div>
    
    `

})

export class LineComponent{


}



// WEBPACK FOOTER //
// ./src/app/Home/line.component.ts